module.exports = __webpack_public_path__ + "img/hiw_img03.e5479576.png";